import { queryInfluxDataList } from '@/api/influx/influx';
import { Emit_Event } from '@/enums/emit-event';
import { MONITORING_DATA_TYPE } from '@/enums/monitoring-data-type';
import { LineChart } from '@/global/components/line-chart';
import TnMessage from '@/global/components/message';
import { MonitorObject } from '@/global/interface/monitor-object/monitor-object'
import { MonitorParameter } from '@/global/interface/monitor-object/monitor-parameter';
import { TimeValue } from '@/global/interface/time-value';
import { emitter } from '@/global/listeners';
import { getDateName } from '@/global/utils/date-utils';
import { Transfer2DisplayScale } from '@/global/utils/unit-type';
import { Skeleton } from 'antd';
import axios from 'axios';
import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import LoadDisplacementChart from '../load-displacement';

interface Iprops {
    monitorObjects: MonitorObject[]
}
export default function MonitorCurvePanel(props: Iprops) {

    const [monitorParameters, setMonitorParameters] = useState<MonitorParameter[]>([]);
    const [activedParam, setActiveParam] = useState<MonitorParameter>();  // 选中的参数
    const [dataList, setDataList] = useState<number[][]>([]) // 数据曲线
    const [loading, setLoading] = useState<boolean>(false) // 曲线loading

    const [needLoadDisp, setNeedLoadDisp] = useState<boolean>(false); // 是否需要展示荷载位移曲线
    const [showLoadDisp, setShowLoadDisp] = useState<boolean>(false); // 当前是否激活荷载位移曲线
    const [dataPoints, setDataPoints] = useState<number[][]>([]); // 组织好的荷载位移数据点

    const [dispParam, setDispParam] = useState<MonitorParameter>();
    const [loadParam, setLoadParam] = useState<MonitorParameter>();

    const [endTime, setEndTime] = useState<number>(null)

    useEffect(() => {
        // 判断是否需要显示荷载位移曲线
        let wpres = monitorParameters.find(item => item.symbol == "wpres");
        let deform = monitorParameters.find(item => item.symbol == "deform");
        if (wpres == null || deform == null) {
            setNeedLoadDisp(false);
            return;
        }
        setNeedLoadDisp(true);
        setDispParam(deform);
        setLoadParam(wpres);
        // 组织荷载位移曲线数据
        generatePoints(wpres, deform);
        const interval = setInterval(() => {
            generatePoints(wpres, deform);
        }, 3000)

        return () => {
            clearInterval(interval)
        }
    }, [monitorParameters])

    // 构建荷载位移的离散点
    const generatePoints = (wpres: MonitorParameter, deform: MonitorParameter) => {
        let queryDeform = queryInfluxDataList(deform.id, deform.symbol, MONITORING_DATA_TYPE.MONITOR_OBJ, { limit: 50 });
        let queryWpres = queryInfluxDataList(wpres.id, wpres.symbol, MONITORING_DATA_TYPE.MONITOR_OBJ, { limit: 50 });
        axios.all([queryDeform, queryWpres]).then(res => {
            let deformList: TimeValue[] = res[0].data || [];
            let wpresList: TimeValue[] = res[1].data || [];

            let points: number[][] = [];
            for (let defPoint of deformList) {
                let time = defPoint.time;
                let wpresPoints = wpresList.filter(item => item.time <= time); // 默认从小到大时间戳
                if (wpresPoints == null || wpresPoints.length == 0) continue;
                let wpresPoint = wpresPoints[wpresPoints.length - 1];

                let point = [defPoint.value * Transfer2DisplayScale(deform.unit), wpresPoint.value * Transfer2DisplayScale(wpres.unit)];
                points.push(point);
            }
            setDataPoints(points);
        })
    }

    useEffect(() => {
        if (props.monitorObjects == null) return;
        let params: MonitorParameter[] = [];
        console.log("===>", props.monitorObjects)
        props.monitorObjects.forEach(item => {
            let rootMonitorParameters = item.rootMonitorParameters.filter(mp => mp.symbol == "deform" || mp.symbol == "wpres" || mp.symbol == "invasion_size");
            if (rootMonitorParameters == null || rootMonitorParameters.length <= 0) return;
            // param.monitorObjectName = item.name;
            params = params.concat(rootMonitorParameters);
        })
        setMonitorParameters(params)
        setActiveParam(params[0])
    }, [props.monitorObjects])

    useEffect(() => {
        flushData(activedParam);
        const interval = setInterval(() => {
            flushData(activedParam);
        }, 3000)

        return () => {
            clearInterval(interval)
        }
    }, [activedParam, endTime])

    // 查询监测参数曲线图
    const flushData = (param: MonitorParameter) => {
        console.log("param", param)
        if (param == null) return;
        setLoading(true);
        // 当天的开始时间和当前时间
        // const startOfDay = new Date(new Date().setHours(0, 0, 0, 0));
        // const now = new Date();
        queryInfluxDataList(param.id, param.symbol, MONITORING_DATA_TYPE.MONITOR_OBJ, {
            limit: 50,
            endTime: endTime
        }).then(res => {
            let valueList: TimeValue[] = res.data || []
            // 组合成数据，展示显示单位下的值
            let scale = Transfer2DisplayScale(activedParam.unit);
            let data = []
            for (let i = 0; i < valueList?.length; i++) {
                data.push([valueList[i].time, valueList[i].value * scale])
            }
            setDataList(data)
            if (param.symbol == "wpres") {
                console.log(data)
            }
        }).catch(() => {
            TnMessage.error("获取历史数据异常")
        }).finally(() => {
            setLoading(false);
        })

    }

    const getChartAxisXLabel = (value: number) => {
        const date = new Date(Number(value));
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0).getTime();
        if (date.getTime() < today) {
            return `${date.getMonth() + 1}-${date.getDate()} ${hours}:${minutes}`
        }
        return `${hours}:${minutes}`;
    }

    const getAxisYLabel = (value: number) => {
        let int = Math.floor(value);
        let decimal = parseFloat((value - int).toPrecision(2));
        return (int + decimal).toString();
    }

    return (
        <div className="monitor-object-param-history-panel">
            <div className="tabs">
                {monitorParameters.map(param => (
                    <div className={classNames({
                        "tab": true,
                        "active": param.id == activedParam?.id
                    })} onClick={() => {
                        setActiveParam(param);
                        setShowLoadDisp(false);
                    }}>
                        <div className="text">{param.name}</div>
                    </div>
                ))}
                {needLoadDisp && (
                    <div className={classNames({
                        "tab": true,
                        "active": showLoadDisp
                    })} onClick={() => {
                        setShowLoadDisp(true)
                        setActiveParam(null)
                    }}>
                        <div className="text">荷载位移曲线</div>
                    </div>
                )}
            </div>
            <div className="data">
                {showLoadDisp && (
                    <LoadDisplacementChart
                        points={dataPoints}
                        t2={dispParam.t2 * Transfer2DisplayScale(dispParam.unit)}
                        t3={dispParam.t3 * Transfer2DisplayScale(dispParam.unit)}
                        t4={dispParam.t4 * Transfer2DisplayScale(dispParam.unit)}
                        xUnit={dispParam.unit}
                        yUnit={loadParam.unit}
                    />
                )}
                {!showLoadDisp && (
                    <LineChart
                        chartValue={getDateName(new Date().getTime())}
                        lineData={dataList || []}
                        getAxisXLabel={getChartAxisXLabel}
                        getAxisYLabel={getAxisYLabel}
                        xLabel="时间"
                        yLabel={activedParam?.unit}
                        toolTipXLabel="时间"
                        toolTipYLabel={activedParam?.name}
                        tLine_1={activedParam?.t2 * Transfer2DisplayScale(activedParam?.unit)}
                        tLine_2={activedParam?.t3 * Transfer2DisplayScale(activedParam?.unit)}
                        tLine_3={activedParam?.t4 * Transfer2DisplayScale(activedParam?.unit)}
                        onChangeEndTime={(e) => { setEndTime(e) }}
                    />
                )}

            </div>
        </div>
    )
}
